import { configureStore, createAction, createListenerMiddleware, isAnyOf, TypedAddListener } from '@reduxjs/toolkit'
import { redirect, redirectPKCE } from './redirect';
import {
  closeFeedback,
  feedback,
  nextFeedback,
} from '../../components/Feedback/feedback';
import { History } from 'history';

import { AppDispatch, AppStartListening, RootState } from '../store';

import { ROUTER_ON_LOCATION_CHANGED } from '@lagunovsky/redux-react-router';
import { fetchUser } from '../../pages/SignIn/sign-in';
import { signOut } from '../../pages/Logout/logout';
import { production, test } from '../../environments';

const listenerMiddlewarePiwik = createListenerMiddleware();

// Replicate @lagunovsky/redux-react-router/push since it is not a real action.
const push = createAction<History>( ROUTER_ON_LOCATION_CHANGED );


// Do not track in development mode

if ( production || test ) {


  // Wrapper for Piwik track event

  const trackEvent = ( category: string, action: string, name: string = '', value: number = 0, dimensions: object = {} ) => {
    // Get instance of tracker

    try {
      _paq.push( [ function () {
        this.trackEvent( category, action, name, value, dimensions );
      } ] );
    } catch ( error ) {
    }

  };


  // Track Feedback / Messages

  listenerMiddlewarePiwik.startListening( {
    actionCreator: feedback,
    effect: async( action, listenerApi ) => {

      trackEvent( 'Feedback', action.payload.message );

    }
  } )

  // Track Redirect, PKCE flow

  listenerMiddlewarePiwik.startListening( {
    actionCreator: redirectPKCE,
    effect: async( action, listenerApi ) => {

      trackEvent( 'Redirect', 'PKCE' );

    }
  })

  // Track Redirect

  listenerMiddlewarePiwik.startListening( {
    actionCreator: redirect,
    effect: async( action, listenerApi ) => {

      trackEvent( 'Redirect', 'Normal' );

    }
  })

  // Track Links

  listenerMiddlewarePiwik.startListening( {
    actionCreator: push,
    effect: async( action, listenerApi ) => {

      trackEvent( 'Link', action.payload.location.pathname );

    }
  })

  // Sign in

  listenerMiddlewarePiwik.startListening( {

    // Why predicate? Seems like the only way for listener middleware
    predicate: (action, currentState ) => {

      if( !action || !action.type ) return false;
      return action.type.includes( fetchUser.typePrefix );
    },
    effect: async( action, listenerApi ) => {

      trackEvent( 'Authentication', 'Sign in' );

    }
  } )

  // Sign out

  listenerMiddlewarePiwik.startListening( {

    // Why predicate? Seems like the only way for listener middleware
    predicate: (action, currentState ) => {

      if( !action || !action.type ) return false;
      return action.type.includes( signOut.typePrefix );
    },
    effect: async( action, listenerApi ) => {

      trackEvent( 'Authentication', 'Sign out' );

    }
  } )

}

export default listenerMiddlewarePiwik;
